import { KeyboardEvent, useState } from 'react'
import { XIcon } from 'lucide-react'

import { Input } from '@/components/ui/input.tsx'

export function TagsInput({
  value,
  onChange,
}: {
  value?: Array<string | number> | null
  onChange: (val: Array<string | number>) => void
}) {
  const [inputValue, setInputValue] = useState('')

  const addValue = (newVal: string | number) => {
    if (newVal && !value?.includes(newVal)) {
      onChange?.([...(value ?? []), newVal])

      setInputValue('')
    }
  }

  const removeValue = (rmVal: string | number) => {
    onChange(value?.filter((v) => v !== rmVal) ?? [])
  }

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      addValue(inputValue)
    }
  }

  return (
    <>
      <Input
        id="enum-input"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyPress}
        placeholder="Aggiungi un valore e premi Invio"
      />
      {value && value?.length > 0 && (
        <div className="mt-1 flex flex-wrap gap-2">
          {value?.map((value) => (
            <span
              key={value}
              className="flex items-center rounded-full bg-secondary px-2 py-1 text-sm text-secondary-foreground"
            >
              {value}
              <button
                type="button"
                onClick={() => removeValue(value)}
                className="ml-2 text-secondary-foreground/50 hover:text-secondary-foreground"
              >
                <XIcon className="size-3" />
              </button>
            </span>
          ))}
        </div>
      )}
    </>
  )
}
